import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AnnouncementService, CompanyOfferModel, config, MemberQuery, ProductCodeQuery, ScreenType } from '@fgb/core';
import { Observable } from 'rxjs';

import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import { ProductCode } from 'src/app/shared/utilities/product-code';
@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit, AfterViewInit, OnDestroy {
  productCode = ProductCode;
  config = config;
  screenType = ScreenType;
  featuredOffers$: Observable<CompanyOfferModel[]>;

  isDragTop = false;

  @ViewChild('homeContainer', { static: false }) homeContainerRef: ElementRef;
  private draggableInstance: any;

  sgb: boolean;
  memberName: string;

  constructor(
    private announcementService: AnnouncementService,
    private router: Router,

    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private memberQuery: MemberQuery,
    private productCodeQuery: ProductCodeQuery
  ) {
    gsap.registerPlugin(Draggable);
  }

  ngOnInit() {
    this.announcementService.fetchAnnouncements().toPromise();
    this.memberQuery.selectMemberDetails().subscribe((member: any) => {
      this.memberName = member.FirstName + ' ' + member.Surname;
    });

    this.sgb = this.productCodeQuery.currentUserIsProductCode(ProductCode.SGB);
  }

  navigateToAccount() {
    this.router.navigate(['/account']);
  }

  ngAfterViewInit() {
    if (this.homeContainerRef) {
      if (this.sgb) {
        this.initiateDraggable(400);
      }
    }
  }

  initiateDraggable(height: number) {
    const containerEl = this.homeContainerRef.nativeElement.closest('fgb-home-page') as HTMLElement;
    const homeContainerHeight = containerEl.clientHeight;
    const barcodeHeight = height;
    const EPS = 2;

    this.ngZone.runOutsideAngular(() => {
      this.draggableInstance = Draggable.create(this.homeContainerRef.nativeElement, {
        type: 'y',
        edgeResistance: 1,
        bounds: { minY: -barcodeHeight, maxY: 0 },
        inertia: true,
        handle: '.grab-point',
        onDrag: () => {
          const y = (this.draggableInstance as any).y as number;
          containerEl.style.height = `${homeContainerHeight + barcodeHeight + y}px`;
        },
        onDragEnd: () => {
          const y = (this.draggableInstance as any).y as number;

          const snapY = Math.abs(y + barcodeHeight) < Math.abs(y) ? -barcodeHeight : 0;

          gsap.to(this.homeContainerRef.nativeElement, {
            y: snapY,
            duration: 0.3,
            onUpdate: () => {
              const currentY = gsap.getProperty(this.homeContainerRef.nativeElement, 'y') as number;
              containerEl.style.height = `${homeContainerHeight + barcodeHeight + (currentY || 0)}px`;
            },
            onComplete: () => {
              this.ngZone.run(() => {
                const atTop = Math.abs(snapY + barcodeHeight) <= EPS;
                if (this.isDragTop !== atTop) {
                  this.isDragTop = atTop;
                  this.cdr.markForCheck();
                }
              });
            },
          });
        },
      })[0];
    });
  }

  ngOnDestroy() {
    if (this.draggableInstance) {
      this.draggableInstance.kill();

      this.draggableInstance = null;
    }
  }
}
